// extracted by mini-css-extract-plugin
module.exports = {"TableTitle":"TableTitle_TableTitle__19FNb","arrows":"TableTitle_arrows__3h95L","title":"TableTitle_title__1yQ87"};